<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'createdAt', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/AdPlacements/queries/adPlacements.gql')
      }"
      :context="{ headers: { 'execution-context': 'public' } }"
      :headers="$options.headersConfig"
      :filters="{
        id: { control: 'text', modifier: 'contains' },
        title: { control: 'text', modifier: 'contains' },
        slug: { control: 'text', modifier: 'contains' },
        isFeatured: {
          control: 'select',
          options: [
            {
              value: true,
              text: 'Да'
            },
            {
              value: false,
              text: 'Нет'
            }
          ],
          dataType: Boolean
        },
        status: {
          control: 'select',
          options: [
            {
              value: true,
              text: 'Да'
            },
            {
              value: false,
              text: 'Нет'
            }
          ],
          dataType: Boolean
        },
        isArchived: {
          control: 'select',
          options: [
            {
              value: true,
              text: 'Да'
            },
            {
              value: false,
              text: 'Нет'
            }
          ],
          dataType: Boolean
        },
        createdAt: { control: 'date-range' }
      }"
      @query-state-updated="getStateQuery"
      :stored-headers="getCurrentViewCols"
      :views-list="getViewList"
      :active-view-key="getActiveViewKey"
      :views-loading="$async.updateMe.$pending"
      @view-changed="updateStoredView"
      @active-view-changed="updateStoredActiveView"
      @remove-view="removeStoredView"
      @data-loaded="onTableDataChange"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ h.text }}
                </span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value]) }}
              </div>
              <div v-else-if="h.text === 'Название рекламного места'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-ad-placement',
                    params: { id: item.id }
                  }"
                  >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div v-else-if="h.type === 'actions'">
                <router-link
                  :to="{
                    name: 'page-ad-placement',
                    params: { id: item.id }
                  }"
                  title="Редактировать"
                  ><v-btn icon><v-icon>mdi-pencil</v-icon></v-btn></router-link
                >
                <a title="Удалить">
                  <v-btn icon @click="deleteAdPlacement(item.id)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                  </v-btn>
                </a>
              </div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirmAdPlacementRemoving" confirmText="Удалить" />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import { formatAmount } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import deleteAdPlacement from '@/services/gql/types/AdPlacements/mutations/deleteAdPlacement.gql'
import updateMeMutation from '@/services/gql/types/Me/mutations/updateMe.gql'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'

export default {
  name: 'GridAdPlacements',
  gridType: 'blogPosts',
  mixins: [gridDependentMixin],
  perPage,
  headersConfig,
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  components: {
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell,
    ConfirmationDialog
  },
  data () {
    return {
      queryState: null
    }
  },
  methods: {
    formatAmount,
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    async deleteAdPlacement (adplacementId) {
      try {
        await this.$refs.confirmAdPlacementRemoving.open()
        await this.$async.deleteAdPlacement.$perform({
          id: Number(adplacementId)
        })
        this.$successMsg('Рекламное место удалено')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e, `Ошибка при удалении поста блога с ID ${adplacementId}`)
      }
    }
  },
  async: {
    deleteAdPlacement (variables) {
      return this.$apollo.mutate({
        mutation: deleteAdPlacement,
        variables
      })
    },
    updateMe (variables) {
      return this.$apollo.mutate({
        mutation: updateMeMutation,
        variables
      })
    }
  }
}
</script>
